import app from '../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { UseAnotherVertical } from './UseAnotherVertical';

app.component('useAnotherVertical', react2angular(UseAnotherVertical, [], ['deviceService']));
